import React from 'react';
// CSS
import styles from './UrlField.module.css';

type UrlFieldProps = {
  url: string;
  text: string;
  urlChanged: (newUrl: string) => void;
  textChanged: (newText: string) => void;
  disabled?: boolean;
};

const UrlField = ({ url, text, urlChanged, textChanged, disabled }: UrlFieldProps) => {
  return (
    !disabled ? (
      <div className={styles.container}>
        <label className={styles.inputLabel}>Display Text</label>
        <textarea
          style={{ border: '1px solid var(--bs-gray-300)', fontSize: '.6rem' }}
          value={text ?? ''}
          onChange={(e) => textChanged(e.target.value)}
        />

        <label className={styles.inputLabel}>URL</label>
        <textarea
          style={{ border: '1px solid var(--bs-gray-300)', fontSize: '.6rem' }}
          value={url ?? ''}
          onChange={(e) => urlChanged(e.target.value)}
        />
      </div>
    ) : (
      <a
        className={styles.linkText}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
      </a>
    )
  );
};

export default UrlField;
